import { Anchor, Box, Button, Input, Select } from "@mantine/core";
import { Input as AntInput, DatePicker, Upload } from "antd";
import {
  IconBuilding,
  IconCalendar,
  IconCar,
  IconId,
  IconMail,
  IconMotorbike,
  IconPhone,
  IconUser,
  IconUsers,
} from "@tabler/icons-react";

import { apiUserUpload } from "@/api";
import dayjs from "dayjs";
import { orpcClient } from "@/lib/orpc-client";
import { single } from "@/lib/orpc-batch";
import { useData } from "@/utility/state/contextAPI";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

function AddEmployeeListPage() {
  const [currentStage, setCurrentStage] = useState(0);
  const [employeeData, setEmployeeData] = useState({
    name: "",
    gender: "男生",
    birthday: "",
    bloodType: "",
    nationalIdNo: "",
    motorbikeLicense: false,
    carLicense: false,
    fullAddress: {
      city: "",
      district: "",
      postalCode: "",
      address: "",
    },
    email: "",
    emergencyContact: "",
    emergencyContactRelationship: "",
    emergencyContactPhoneNumber: "",
    user: "",
    note: "",
  });
  const [uploadId, setUploadId] = useState(null);
  const [uploadImg, setUploadImg] = useState("");
  const [error, setError] = useState({
    submit: {
      isError: false,
      errorMessage: "",
    },
  });
  const [uploadState, setUploadState] = useState(false);
  const {
    modal: { contextOpenModal, contextCloseModal, contextSetModalContent },
  } = useData();
  const navigate = useNavigate();
  const { modal } = useData();

  const handleCancelButton = () => {
    contextOpenModal();
    contextSetModalContent({
      title: "您確定要取消新增員工嗎？",
      onCancel: contextCloseModal,
      onOk: () => {
        contextCloseModal();
        navigate(`/hrMainPage/employees`);
      },
    });
  };

  const handleChangeImg = async (info) => {
    setUploadState(true);
    if (!uploadState) {
      const file = info.file.originFileObj;

      const formData = new FormData();
      formData.append("files", file, file.name);
      formData.append("name", info.file.name);

      const fileInfo = {
        alternativeText: localStorage.getItem("companyId"),
      };
      formData.append("fileInfo", JSON.stringify(fileInfo));

      // Log the contents of FormData
      // for (let [key, value] of formData.entries()) {
      //   console.log(key, value);
      // }

      let result = await apiUserUpload(formData);

      if (result[0]?.id) {
        setUploadId(result[0]?.id);
        setUploadImg(URL.createObjectURL(file));
      }
      setUploadState(false);
    }
  };

  const handleChangeEmployeeData = (value, type) => {
    setEmployeeData({
      ...employeeData,
      [type]: value,
    });
  };

  const handleChangeAddressData = (value, type) => {
    setEmployeeData({
      ...employeeData,
      fullAddress: {
        ...employeeData?.fullAddress,
        [type]: value,
      },
    });
  };

  const {
    name,
    user,
    gender,
    birthday,
    bloodType,
    nationalIdNo,
    motorbikeLicense,
    carLicense,
    fullAddress: { city, district, postalCode, address },
    email,
    emergencyContact,
    emergencyContactRelationship,
    emergencyContactPhoneNumber,
    //img,
  } = employeeData || {};

  const handleSubmit = async (employeeData) => {
    try {
      const employee = await orpcClient.employee.addMember({
        email: employeeData.email,
      });

      if (!employee) {
        setError((prev) => ({
          ...prev,
          submit: {
            isError: true,
            errorMessage: "Failed to add employee",
          },
        }));
        return;
      }

      const hasAddress =
        employeeData.fullAddress.city &&
        employeeData.fullAddress.district &&
        employeeData.fullAddress.postalCode &&
        employeeData.fullAddress.address;

      const updateData: any = {
        id: employee.id,
        name: employeeData.name,
        gender: employeeData.gender === "男生" ? "male" : "female",
        bloodType: employeeData.bloodType || undefined,
        nationalIdNo: employeeData.nationalIdNo || undefined,
        motorbikeLicense: employeeData.motorbikeLicense,
        carLicense: employeeData.carLicense,
        address: hasAddress
          ? {
              city: employeeData.fullAddress.city,
              district: employeeData.fullAddress.district,
              postalCode: Number(employeeData.fullAddress.postalCode),
              address: employeeData.fullAddress.address,
            }
          : null,
        emergencyContact: employeeData.emergencyContact || undefined,
        emergencyContactRelationship:
          employeeData.emergencyContactRelationship || undefined,
        emergencyContactPhoneNumber:
          employeeData.emergencyContactPhoneNumber || undefined,
        note: employeeData.note || undefined,
      };

      if (employeeData.birthday) {
        updateData.birthday = new Date(employeeData.birthday);
      }

      if (uploadId) {
        updateData.profile = String(uploadId);
      }

      const updatedEmployee = await single(
        orpcClient.employee.update([updateData])
      );

      if (updatedEmployee) {
        navigate(`/hrMainPage/employee/${updatedEmployee.id}`);
      }
    } catch (error) {
      console.error("addEmployee_error", error);
      const errorMessage =
        error instanceof Error ? error.message : "Failed to add employee";
      setError((prev) => ({
        ...prev,
        submit: {
          isError: true,
          errorMessage,
        },
      }));
    }
  };

  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="w-[765px] rounded-xl bg-white p-14">
        <>
          <div className="py-3 text-6xl font-bold" style={{ color: "#6F6F6F" }}>
            新增員工
          </div>
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={() => !uploadState}
            onChange={handleChangeImg}
          >
            {uploadImg ? (
              <img
                src={uploadImg}
                alt="avatar"
                style={{
                  width: "100%",
                }}
              />
            ) : (
              "upload image"
            )}
          </Upload>
          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            基本資訊
          </div>
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>姓名</div>
            <Input
              value={name}
              onChange={(e) => handleChangeEmployeeData(e.target.value, "name")}
              placeholder="Input component"
              leftSection={<IconUser size={16} />}
            />
          </div>
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>User *</div>
            <Input
              value={user}
              onChange={(e) => handleChangeEmployeeData(e.target.value, "user")}
              placeholder="Input component"
              leftSection={<IconUser size={16} />}
            />
          </div>
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>生理性別</div>
            <Select
              value={gender}
              data={["男生", "女生"]}
              onChange={(value) => handleChangeEmployeeData(value, "gender")}
              placeholder="Input component"
              leftSection={<IconUser size={16} />}
            />
          </div>
          <div className="flex items-center justify-start">
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>生日＊</div>
              <DatePicker
                value={birthday ? dayjs(birthday) : null}
                onChange={(e) =>
                  handleChangeEmployeeData(
                    e ? e.format("YYYY-MM-DD") : "",
                    "birthday"
                  )
                }
              />
            </div>

            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>血型</div>
              <Input
                placeholder="Input component"
                leftSection={<IconUser size={16} />}
                value={bloodType}
                onChange={(e) =>
                  handleChangeEmployeeData(e.target.value, "bloodType")
                }
              />
            </div>
            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>身分證號</div>
              <Input
                placeholder="Input component"
                leftSection={<IconId size={16} />}
                value={nationalIdNo}
                onChange={(e) =>
                  handleChangeEmployeeData(e.target.value, "nationalIdNo")
                }
              />
            </div>
          </div>
          <div className="flex items-center justify-start">
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>駕照</div>
            </div>

            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>機車</div>
              <Select
                value={motorbikeLicense == true ? "有" : "沒有"}
                data={["有", "沒有"]}
                onChange={(value) =>
                  handleChangeEmployeeData(
                    value === "有" ? true : false,
                    "motorbikeLicense"
                  )
                }
                placeholder="Input component"
                leftSection={<IconMotorbike size={16} />}
              />
            </div>
            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>汽車</div>
              <Select
                value={carLicense == true ? "有" : "沒有"}
                data={["有", "沒有"]}
                onChange={(value) =>
                  handleChangeEmployeeData(
                    value === "有" ? true : false,
                    "carLicense"
                  )
                }
                placeholder="Input component"
                leftSection={<IconCar size={16} />}
              />
            </div>
          </div>

          <div className="py-4 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            聯絡地址
          </div>
          <div className="flex items-center justify-start">
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>縣市＊</div>
              <Input
                placeholder="Input component"
                leftSection={<IconBuilding size={16} />}
                value={city}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "city")
                }
              />
            </div>

            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>行政區＊</div>
              <Input
                placeholder="Input component"
                leftSection={<IconBuilding size={16} />}
                value={district}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "district")
                }
              />
            </div>
            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>郵遞區號＊</div>
              <Input
                placeholder="Input component"
                leftSection={<IconId size={16} />}
                value={postalCode}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "postalCode")
                }
              />
            </div>
            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>地址＊</div>
              <Input
                placeholder="Input component"
                leftSection={<IconBuilding size={16} />}
                value={address}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "address")
                }
              />
            </div>
          </div>

          <div className="py-4 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            聯絡資訊
          </div>
          <div className="flex items-center justify-start">
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>Email / 帳號 *</div>
              <Input
                placeholder="Input component"
                leftSection={<IconMail size={16} />}
                value={email}
                onChange={(e) =>
                  handleChangeEmployeeData(e.target.value, "email")
                }
              />
            </div>

            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>緊急連絡人</div>
              <Input
                placeholder="Input component"
                leftSection={<IconUsers size={16} />}
                value={emergencyContact}
                onChange={(e) =>
                  handleChangeEmployeeData(e.target.value, "emergencyContact")
                }
              />
            </div>
          </div>
          <div className="flex items-center justify-start">
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>關係</div>
              <Input
                placeholder="Input component"
                value={emergencyContactRelationship}
                leftSection={<IconUsers size={16} />}
                onChange={(e) =>
                  handleChangeEmployeeData(
                    e.target.value,
                    "emergencyContactRelationship"
                  )
                }
              />
            </div>

            <div className="py-4 pl-2">
              <div style={{ color: "#6F6F6F" }}>緊急聯絡人電話</div>
              <Input
                placeholder="Input component"
                leftSection={<IconPhone size={16} />}
                value={emergencyContactPhoneNumber}
                onChange={(e) =>
                  handleChangeEmployeeData(
                    e.target.value,
                    "emergencyContactPhoneNumber"
                  )
                }
              />
            </div>
          </div>

          <div className="py-4">
            <div className="text-2xl font-bold" style={{ color: "#6F6F6F" }}>
              備註
            </div>
            <AntInput.TextArea
              placeholder="Input placeholder"
              value={employeeData.note || ""}
              onChange={(e) => handleChangeEmployeeData(e.target.value, "note")}
            />
          </div>

          <div className="flex">
            <Button
              variant="default"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => handleCancelButton()}
            >
              取消
            </Button>

            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => handleSubmit(employeeData)}
            >
              新增
            </Button>
          </div>
          <div className="text-xl font-bold">
            <Input.Error>{error.submit.errorMessage}</Input.Error>
          </div>
        </>
      </div>
    </div>
  );
}
export default AddEmployeeListPage;
